<script setup lang="ts">
    import { useTheme } from 'vuetify';
    import { 
        useAppStore,
        useAuthStore } from '#imports';

    /* Store variables */
    const { langs, txt } = storeToRefs(useAppStore());
    const authStore = useAuthStore();
    const { active_emp, active_emp_id, isDark, isPending, profile, redeemedCodes } = storeToRefs(authStore);
    const { updateProfile } = authStore;
    const { fetchLinkCodes, logOut } = authStore;
    const lang_id = ref<string>(profile.value ? profile.value.lang_id : 'en');

    /* Private variables */
    const _menu = ref<boolean>(false);
    const _theme = useTheme();

    watch(isDark, () => { setTheme(); });
    watch(lang_id, () => {
        profile.value.lang_id = lang_id.value;
        updateProfile(profile.value);
    });

    async function handleLogOut(): Promise<void> {
        await logOut();
        navigateTo('/');
    }

    function setTheme(): void {
        _theme.global.name.value = isDark.value ? 'theme_dark' : 'theme_light';
    }

    function init(): void {
        console.log(`init() - profile.value:`, profile.value);
        if (!profile.value || !profile.value.active_emp_id) return;

        setTheme();

        active_emp_id.value = profile.value.active_emp_id;
        console.log(`site settings init fetchLinkCodes()`);
        fetchLinkCodes();
    }

    init();
</script>

<template>
    <v-menu v-if="profile"
        v-model="_menu"
        :close-on-content-click="false"
        location="bottom">
        <template v-slot:activator="{ props }">
            <button v-bind="props"
                class="d-flex align-center cursor-pointer">
                <div class="text-end">
                    <p>{{ profile.fname }} {{ profile.lname }}</p>
                    <p v-if="active_emp && active_emp.id"
                        class="text-caption">
                        <span class="color-secondary">
                            {{ active_emp.location.name }}
                        </span>
                        <span class="color-primary text-caption">
                            &nbsp;{{ txt.roles[active_emp.role.id - 1] }}
                        </span>
                    </p>
                </div>
                <v-icon
                    icon="$mdi-account-circle"
                    class="pr-3 pl-6"
                    color="secondary"
                    size="x-large"
                    style="background: transparent" />
            </button>
        </template>

        <v-card 
            class="mt-3"
            :disabled="isPending">
            <v-card-text class="px-6">
                <v-select v-if="active_emp_id && redeemedCodes.length > 1"
                    :label="txt.location"
                    v-model="active_emp_id"
                    :items="redeemedCodes"
                    item-title="location.name"
                    item-value="id"
                    color="primary"
                    hide-details />
                <v-switch
                    :label="txt.darkMode"
                    v-model="isDark"
                    color="primary"
                    hide-details />
                <v-select
                    :label="txt.language"
                    v-model="lang_id"
                    :items="langs"
                    item-title="name"
                    item-value="id"
                    color="primary"
                    hide-details />
            </v-card-text>
            
            <v-card-actions>
                <v-spacer />
                <v-btn
                    class="px-2"
                    color="secondary"
                    @click="handleLogOut">
                    {{ txt.logOut }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-menu>
</template>